import React from "react";
import { useTranslation } from "react-i18next";
import { RNRazmerLotSuggestion } from "../hooks/useRNRazmerLots";

interface Props {
  suggestion?: RNRazmerLotSuggestion;
  field: "serial" | "deadline";
  unitCode?: string;
}

// "2027-03-15" -> "03.2027"; anything else is shown as-is.
const formatDeadline = (value: string): string => {
  const m = /^(\d{4})-(\d{2})/.exec(value || "");
  return m ? `${m[2]}.${m[1]}` : value || "";
};

const formatQty = (n: number): string => String(n).replace(".", ",");

/**
 * Read-only grey suggestion lines for a Размерување row without a manually typed serial.
 * Rendered in normal flow; the input is laid over it in the table cell.
 */
const RNRazmerLotLines: React.FC<Props> = ({ suggestion, field, unitCode }) => {
  const { t } = useTranslation();
  if (!suggestion) return null;
  const { lots, shortfall } = suggestion;
  const multi = lots.length > 1;
  return (
    <div className="pointer-events-none px-1 text-[11px] leading-5 text-gray-500">
      {lots.map((lot, idx) => (
        <div key={`${lot.serial}-${idx}`} className="truncate">
          {field === "serial"
            ? multi
              ? `${lot.serial} · ${formatQty(lot.quantity)} ${unitCode || ""}`.trim()
              : lot.serial
            : formatDeadline(lot.deadline)}
        </div>
      ))}
      {field === "serial" && shortfall > 0 && (
        <div className="truncate text-red-600">
          {t("rnRazmerLots.shortfall", { qty: formatQty(shortfall), unit: unitCode || "" })}
        </div>
      )}
    </div>
  );
};

export default RNRazmerLotLines;
